import { NetworkErrors } from 'context';

import { PATHS } from './config';

/**
 * ТЗ 0074: куда приостановленному студенту можно. Всё остальное — занятия,
 * вложения (/attachments идёт мимо MainTemplate), опросы, дипломы, карьерный
 * центр со всеми редиректами старых адресов и даже неизвестный адрес — ведёт
 * на /invoices.
 */
export const SUSPENSION_ALLOWED_PATHS: string[] = [
  PATHS.invoices,
  PATHS.login,
  PATHS.signUp,
  `/${NetworkErrors.pageIsNotAvailable}`,
  `/${NetworkErrors.internalServerError}`,
  `/${NetworkErrors.serviceUnavailable}`,
  `/${NetworkErrors.otherError}`,
];

export const isSuspensionAllowedPath = (pathname: string): boolean => {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return SUSPENSION_ALLOWED_PATHS.includes(normalized);
};
